/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_StagesInputs */

const cs_reports_stages = /** @type {(inputs: Reports_StagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fáze pipeline`)
};

const en_reports_stages = /** @type {(inputs: Reports_StagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline stages`)
};

/**
* | output |
* | --- |
* | "Pipeline stages" |
*
* @param {Reports_StagesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_stages = /** @type {((inputs?: Reports_StagesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_StagesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_stages(inputs)
	return cs_reports_stages(inputs)
});